import { Card, CardActionArea, CardContent, Stack, Typography } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

export function ChoiceCard({ selected, title, description, icon, onClick, badge, disabled = false, children }) {
  return (
    <Card
      sx={{
        position: 'relative',
        borderColor: selected ? 'primary.dark' : 'divider',
        boxShadow: selected ? '0 16px 44px rgba(255,182,72,.16)' : undefined,
        opacity: disabled ? .55 : 1,
      }}
    >
      <CardActionArea onClick={onClick} disabled={disabled} sx={{ height: '100%', alignItems: 'stretch' }}>
        <CardContent sx={{ p: 2.6, height: '100%' }}>
          <Stack direction="row" spacing={2} alignItems="flex-start">
            {icon}
            <Stack flex={1} minWidth={0}>
              <Stack direction="row" justifyContent="space-between" gap={2}>
                <Typography variant="h4" sx={{ fontSize: 19 }}>{title}</Typography>
                {selected && <CheckCircleRoundedIcon color="primary" />}
              </Stack>
              {badge && <Typography className="mono-label" sx={{ color: 'primary.dark', mt: .5 }}>{badge}</Typography>}
              <Typography color="text.secondary" sx={{ mt: .8, fontSize: 14.5 }}>{description}</Typography>
              {children}
            </Stack>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
